import AOS from 'aos';
window.AOS = AOS;
